import { useQuery } from '@tanstack/react-query';
import { useRouter } from '@tanstack/react-router';
import type { AdminApi } from '../../../api/client.ts';

/** The variables a message may use (BB-54): the environment's, plus the campaign's trigger data when one is given. */
export function useTemplateVariables(environmentId: string, campaignId?: string) {
  const { api } = useRouter().options.context as { api: AdminApi };
  return useQuery({
    queryKey: ['templating-variables', environmentId, campaignId ?? null],
    queryFn: () => api.templatingVariables(environmentId, campaignId),
    staleTime: 60_000,
  });
}
